export default __webpack_public_path__ + "static/media/logo-xd.1c8a4cfc.svg";